import { render } from "./cheque.vue?vue&type=template&id=1a1c6a9f&scoped=true"
import script from "./cheque.vue?vue&type=script&lang=js"
export * from "./cheque.vue?vue&type=script&lang=js"

import "./cheque.vue?vue&type=style&index=0&id=1a1c6a9f&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1c6a9f"]])

export default __exports__